import React from 'react';
import logo from '../images/logo-white-transparent.png';
import SocialMedia from "../components/socialMedia";

function Header() {
  return (
      <header>
          <div className=" bg-blue-500  w-full text-center   py-1">
              <SocialMedia customClasses='flex justify-center gap-4' showIconText={false}/>
          </div>
          <div className="flex flex-col items-center justify-center p-2 pt-4 bg-blue-600">
              <img src={logo} alt="threadify logo" className="w-h4 h-24"/>
          </div>
      </header>
  );
}

export default Header;